import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import axios from "axios";
import CommunicationTable from "../../components/CommunicationTable";
import { axiosErrorHandler } from "../../../../swzutils";
const ConsignmentCommunications = (props) => {
    const [loading, setLoading] = React.useState(false);
    const [communications, setCommunications] = React.useState([]);
    useEffect(() => {
        loadCommunications();
    }, [props.consignmentId]);
    const loadCommunications = () => {
        setLoading(true);
        if (props.consignmentId) {
            axios.get(`/admin/v1/consignments/${props.consignmentId}/communications`).then(response => {
                setCommunications(response.data);
                props.onCommunicationsLoaded?.(response.data);
            }).catch((error) => {
                if (error.response.status !== 404) {
                    axiosErrorHandler(error);
                }
            }).finally(() => {
                setLoading(false);
            });
        }
    };
    return (_jsx(CommunicationTable, { loading: loading, communications: communications }));
};
export default ConsignmentCommunications;
